import { useContext } from "react";
import { Context } from "../context/Context";
import Hero from "../components/Hero";
import Content from "../components/Content";
import Calender from "../components/Calender";
import Pricing from "../components/Pricing";
import Faq from "../components/Faq";
import Testimonials from "../components/Testimonials";
import SubscriptionPopup from "../components/SubscriptionPopup";


const Home = () => {
  const { dark } = useContext(Context);

  return (
    <div className="bg-[#fafafa] dark:bg-black transition-colors duration-300">
      {/* GRID BACKGROUND */}
      <div
        className="fixed inset-0 z-0"
        style={{
          backgroundImage: dark
            ? `repeating-linear-gradient(0deg, rgba(255,255,255,0.05) 0px, rgba(255,255,255,0.05) 1px, transparent 1px, transparent 24px),
               repeating-linear-gradient(90deg, rgba(255,255,255,0.05) 0px, rgba(255,255,255,0.05) 1px, transparent 1px, transparent 24px)`
            : `repeating-linear-gradient(0deg, rgba(0,0,0,0.05) 0px, rgba(0,0,0,0.05) 1px, transparent 1px, transparent 24px),
               repeating-linear-gradient(90deg, rgba(0,0,0,0.05) 0px, rgba(0,0,0,0.05) 1px, transparent 1px, transparent 24px)`,
        }}
      />

      {/* FLOATING DOTS */}
      <div
        className="fixed inset-0 z-0 opacity-30 pointer-events-none animate-[floatDots_60s_linear_infinite]"
        style={{
          backgroundImage:
            "radial-gradient(circle, rgba(255,255,255,0.2) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />

      {/* NOISE TEXTURE */}
      <div
        className="fixed inset-0 z-0 opacity-20 mix-blend-soft-light pointer-events-none"
        style={{
          backgroundImage:
            "url('https://grainy-gradients.vercel.app/noise.svg')",
        }}
      />

      {/* HERO GLOW */}
      <div className="fixed top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-purple-500/30 blur-[120px] rounded-full z-0"></div>

      {/* MAIN CONTENT */}
      <div className="relative z-10 pt-28">
        {" "}
        {/* pt-28 to avoid navbar overlap */}
        {/* HERO */}
        <Hero />
        <SubscriptionPopup />

        <div className="my-20    w-full"></div>
        {/* CONTENT */}
        <Content />
        {/* Booking Calender */}
        <Calender />
        {/* pricing section */}
        <Pricing />
              {/* HEADING */}
      <div className="text-center">
        <h2 className="my-20 text-2xl sm:text-3xl md:text-4xl font-semibold text-black dark:text-white">
          Testimonials 
        </h2>
      </div>
        {/* Testimonials section */}
        <Testimonials />

        {/* FAQ section */}
        <Faq />
      </div>

      {/* DOT ANIMATION KEYFRAME */}
      <style>
        {`
        @keyframes floatDots {
          from { transform: translateY(0px); }
          to { transform: translateY(-100px); }
        }
        `}
      </style>
    </div>
  );
};

export default Home;
